import { derived } from 'svelte/store';
import { activityStore } from './activity';
import { areaStore } from './area';
import { offerStore } from './offer';
import { openingHourStore } from './opening-hour';
import { sessionStore } from './session';
import { widget } from './widget';

export let canUseFastTrackOnboarding = derived(
	[activityStore, areaStore, offerStore, sessionStore],
	([$activityStore, $areaStore, $offerStore, $sessionStore]) => {
		return (
			$activityStore.filter((activity) => !activity.archivedAt).length <= 1 &&
			$areaStore.filter((area) => !area.archivedAt).length <= 1
		);
	}
);

export let hasConfigurationIssues = derived(
	[areaStore, sessionStore, offerStore],
	([$areaStore, $sessionStore, $offerStore]) => {
		return (
			$areaStore.filter((area) => !area.archivedAt).length === 0 ||
			$sessionStore.filter((session) => !session.archivedAt).length === 0 ||
			$offerStore.filter((offer) => !offer.archivedAt).length === 0
		);
	}
);

export let stepCompletedOpeningHour = derived([openingHourStore], ([$openingHourStore]) =>
	$openingHourStore.some(
		(openingHour) =>
			openingHour.type === 'default' &&
			openingHour.schedule.some((schedule) => schedule.openingHours.length > 0)
	)
		? 'completed'
		: 'current'
);

export let stepCompletedActivity = derived(
	[stepCompletedOpeningHour, activityStore],
	([stepCompletedOpeningHour, $activityStore]) =>
		stepCompletedOpeningHour !== 'completed'
			? 'upcoming'
			: $activityStore.some((activity) => !activity.archivedAt)
				? 'completed'
				: 'current'
);
export let stepCompletedArea = derived(
	[stepCompletedActivity, areaStore],
	([stepCompletedActivity, $areaStore]) =>
		stepCompletedActivity !== 'completed'
			? 'upcoming'
			: $areaStore.some((area) => !area.archivedAt)
				? 'completed'
				: 'current'
);

export let stepCompletedSession = derived(
	[stepCompletedArea, sessionStore],
	([stepCompletedArea, $sessionStore]) =>
		stepCompletedArea !== 'completed'
			? 'upcoming'
			: $sessionStore.some((session) => !session.archivedAt)
				? 'completed'
				: 'current'
);

export let stepCompletedOffer = derived(
	[
		stepCompletedSession,
		stepCompletedActivity,
		stepCompletedArea,
		stepCompletedOpeningHour,
		offerStore
	],
	([
		stepCompletedSession,
		stepCompletedActivity,
		stepCompletedArea,
		stepCompletedOpeningHour,
		$offerStore
	]) =>
		stepCompletedSession !== 'completed' ||
		stepCompletedActivity !== 'completed' ||
		stepCompletedArea !== 'completed' ||
		stepCompletedOpeningHour !== 'completed'
			? 'upcoming'
			: $offerStore.some((offer) => !offer.archivedAt)
				? 'completed'
				: 'current'
);

export let stepCompletedOfferPublished = derived(
	[stepCompletedOffer, offerStore],
	([stepCompletedOffer, $offerStore]) =>
		stepCompletedOffer !== 'completed'
			? 'upcoming'
			: $offerStore.some((offer) => !offer.archivedAt && offer.isActive)
				? 'completed'
				: 'current'
);

export let stepCompletedWidget = derived(
	[stepCompletedOfferPublished, widget],
	([stepCompletedOfferPublished, $widget]) =>
		stepCompletedOfferPublished !== 'completed'
			? 'upcoming'
			: $widget?.theme.primary !== '#00b300'
				? 'completed'
				: 'current'
);
